import React, { useEffect, useState, lazy } from 'react';
import { Button } from 'react-bootstrap';
import { InterveneActions } from '../../../Services/_actions/Intervene/intervene.actions';
const CommonTable = lazy(() => import('../../../components/Shared/Tables'));
const ReactPagination = lazy(() => import('../../../components/Shared/Pagination'));
const TableHeader = lazy(() => import('../../../components/Shared/TableHeader'));
const DataNotFound = lazy(() => import('../../../components/Shared/DataNotFound'));
import LoadingWrapper from '../../../components/Shared/LoadingWrapper/index';

export const ContactList = () => {
  const actions = InterveneActions();
  const [filters, setFilters] = useState({ page: 0, typeOfEntity: '' });
  const [list, setList] = useState({});
  const [isLoading, setIsloading] = useState(false);
  const columns = [
    {
      dataField: 'index',
      text: 'Index',
      formatter: (cell, row, index) => {
        return index + 1;
      },
    },
    {
      dataField: 'whatsapp_name',
      text: 'Name',
    },
    {
      dataField: 'phone_number',
      text: 'Number',
    },
    {
      dataField: 'user_type',
      text: 'Status',
    },
    {
      dataField: 'updated_at',
      text: 'Last Active	',
    },
    {
      dataField: 'created_at',
      text: 'Created At',
    },
  ];

  const getContactList = async () => {
    let res = await actions.getContactList(filters);
    setList(res);
    setIsloading(true);
  };
  const handlePageChange = (event) => setFilters({ ...filters, page: event?.selected });

  useEffect(() => {
    setIsloading(false);
    getContactList();
  }, [filters]);

  return (
    <div>
      <TableHeader headerValue="Contact" />
      <Button varient="primary">Back</Button>
      {!isLoading && <LoadingWrapper />}
      {isLoading && list && list?.users && list?.total_count > 0 ? (
        <>
          <CommonTable id={'session_id'} columnsData={columns} rowData={list.users} />
          {list?.total_count > 20 && (
            <ReactPagination
              pageNo={filters.page}
              pageSize={20}
              totalItems={list.total_count}
              onPageChange={handlePageChange}
            />
          )}
        </>
      ) : (
        <DataNotFound />
      )}
    </div>
  );
};
